import React from 'react';
import '../CSS/Project.css'
import { faCircleArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Pages from './Pages';
import { HomePageRef } from '../components/HomePageRef';
import { Link } from 'react-router-dom';
// import ClipLoader from 'react-spinners/ClipLoader';
// import BarLoader from 'react-spinners/ClipLoader';
// import { CSSRef } from '../components/CSSRef';




class Project extends Pages {

    constructor(props) {
        super(props);
        this.vidRef = React.createRef();
    };
    componentDidMount() {
        window.scrollTo(0, 0)
        // setTimeout(function () {
        //     this.setState({ isLoading: false });
        // }.bind(this), 5000);
    }

    imgRender = (refObj) => {
        return (
            <>
                {refObj.map((item, index) => (
                    <img src={item.url} alt='' key={item.url}
                        style={{ width: '100%', verticalAlign: 'bottom' }}
                    />
                ))}
            </>

        )
    }


    render() {
        return (
            <>
                {/* {this.state.isLoading ? <div className='load-container'><BarLoader color={'silver'} size={150} loading={this.state.isLoading} cssOverride={CSSRef} /></div> : null} */}
                <div className='cover-title' >
                    <p id='gold'>
                    (WE GOT GOLD!)
                        <br/><br/>
                    </p>
                    <p id={'hku-igem-2022'}>

                        HKU iGEM 2022
                    </p>
                    <p id={'igem-title'}>
                        AMPED
                    </p>
                    <p id={'igem-short-intro'}>
                        Transgenic AMP-expressing
                        <br />
                        microalgae fish feed supplement that deliver passive immunity and
                        <br />
                        nutrition to fish in aqua systems plagued with AMR
                        <br />

                    </p>
                    {/* This btn link to intro video on the bottom */}
                    <button
                        className='btn-project'
                        onClick={() => this.scroll(this.vidRef)}
                    >
                        Learn more
                        <FontAwesomeIcon id={'learnmore-icon'} icon={faCircleArrowRight} />
                    </button>
                </div>
                <div>
                    {this.imgRender(HomePageRef)}
                    <Link to='/description'>
                        <img src={'https://static.igem.wiki/teams/4241/wiki/new-front-page/15.png'} alt=''
                            style={{ width: '100%', verticalAlign: 'bottom' }}
                        />
                    </Link>

                </div>



                <div className='vid-container' ref={this.vidRef}>

                    <iframe
                        className='promo-vid'
                        title="HKU_HongKong: AMPed (2022) - Project Promotion [English]"
                        src="https://video.igem.org/videos/embed/44d52464-8dc2-4f9d-b070-d4fc3ab89a3f"
                        frameBorder="0"
                        allowFullScreen=""
                        sandbox="allow-same-origin allow-scripts allow-popups"
                    />
                </div>
            </>
        );
    }
}


export default Project;
